$(document).ready(function(){
	$('a[href^="#"], .scrollTop a').on('click', function(e){
		e.preventDefault();
		var id = $(this).attr("href");
		if (id == '#cookie-policy') {
      tarteaucitron.userInterface.openPanel();
		} else {			
			$('html, body').animate({
				scrollTop: $(id).offset().top - 117
			}, 'slow');
			$(id).focus();
			return false;
		}
	});
});
// window.addEventListener('load', function () {
//   document.querySelectorAll('a[href^="#"], .scrollTop a').forEach(anchor => {
//     anchor.addEventListener('click', function (e) {
//       e.preventDefault();
//       if (this.getAttribute('href') == '#cookie-policy') {
//         tarteaucitron.userInterface.openPanel();
//       } else {      
//         document.querySelector(this.getAttribute('href')).scrollIntoView({
//           behavior: 'smooth'
//         });
//       }
//     });
// 	});
// });